<script>
import { mapGetters } from 'vuex'
import SearchForm from '@/components/views/searchForm/SearchForm.vue'
import SearchLabel from '@/components/services/ui/searchLabel.vue'
import SearchControls from '@/components/services/ui/searchControls.vue'
import infiniteScroll from '@/components/views/infiniteScroll/infiniteScroll.vue'
import hotelsFilter from './views/HotelsFilter.vue'
import {
  hotelsCards,
  hotelsTable
} from './ui'
import {
  nToWord,
  formatThousands,
} from '@/utils/helpers'

export default {
  name: 'search-hotels',
  components: {
    SearchForm,
    SearchLabel,
    SearchControls,
    infiniteScroll,
    hotelsFilter,
    hotelsCards,
    hotelsTable,
  },
  metaInfo: {
    title: 'Поиск отелей'
  },
  data: () => ({
    isSearch: false,
    formIsShown: true,
    searchLabelFields: ['service', 'placeName', 'checkInDate', 'duration', 'rooms']
  }),
  computed: {
    ...mapGetters('hotelsSearch', {
      collection: 'getCollection',
      pagination: 'getPagination',
      errors: 'getErrors',
      isLoading: 'isLoading',
      isLoadingMore: 'isLoadingMore',
      isUpdating: 'isUpdating',
      form: 'getForm',
      searchForm: 'getFormForSearch',
      isFiltersApplied: 'isFiltersApplied',
      isFiltersDisabled: 'isFiltersDisabled',
      isEmptySearchResult: 'isEmptySearchResult',
      viewType: 'getViewType'
    }),
    showForm: {
      get() {
        return this.$store.getters['hotelsSearch/showForm']
      },
      set(value) {
        this.$store.commit('hotelsSearch/setFormShowed', value)
      }
    },
    showSearch: {
      get() {
        return this.$store.getters['hotelsSearch/showSearch']
      },
      set(value) {
        this.$store.commit('hotelsSearch/setSearchShowed', value)
      }
    },
    resultsCount() {
      const count = Number(this.$store.getters['hotelsSearch/getPagination'].total)

      return `${formatThousands(count)} ${nToWord(count, ['предложение', 'предложения', 'предложений'])}`
    },
    noResults() {
      return !this.collection.length && !(this.isLoading || this.isUpdating)
    },
  },
  created() {
    if (Object.keys(this.$route.query).length) {
      this.$store.commit('hotelsSearch/setSearchFieldsFromQueryParams', this.$route.query)
      this.$store.commit('hotelsSearch/setIsLoading', true)

      this.$store.dispatch('hotelsSearch/getCollection', this.searchForm)
    } else {
      this.showForm = true
      this.showSearch = false
    }
  },
  beforeDestroy() {
    this.$store.commit('hotelsSearch/setInitialState')
  },
  methods: {
    loadMore() {
      this.$store.commit('hotelsSearch/setIsLoadingMore', true)
      this.$store.commit('hotelsSearch/setIsFiltersDisabled', true)

      this.showForm = false

      this.$store.dispatch('hotelsSearch/updateCollection', {
        ...this.searchForm,
        page: this.pagination.page + 1
      })
    },
    update() {
      this.$store.commit('hotelsSearch/setIsUpdating', true)
      this.$store.commit('hotelsSearch/setIsFiltersDisabled', true)
      this.$store.commit('hotelsSearch/setIsFiltersApplied', true)
      this.$store.commit('hotelsSearch/setCollection', [])

      this.showForm = false

      this.$store.dispatch('hotelsSearch/updateCollection', {
        ...this.searchForm,
        page: 1
      })
    },
    resetFilters() {
      this.$store.commit('hotelsSearch/clearFilters')

      this.update()
    },
    startNewSearch() {
      this.showForm = true
      this.showSearch = false
    }
  }
}
</script>

<template>
  <div>
    <search-form v-show="showForm" />
    <div
      v-if="showSearch"
      class="search-content search-content--hotels-search"
    >
      <div>
        <hotels-filter
          v-if="!(noResults && isEmptySearchResult)"
          @filter="update"
          @reset="resetFilters"
        />
      </div>
      <div class="search-content__results">
        <div class="search-content__results-header">
          <search-label
            :required-fields="searchLabelFields"
            @click="showForm = true"
          />
          <div class="search-content__results-count">
            <span v-if="isLoading || isUpdating">Идет поиск</span>
            <span v-else>Найдено {{ resultsCount }}</span>
          </div>
        </div>
        <search-controls
          store-module="hotelsSearch"
          getter-field-name="getField"
          setter-field-name="setField"
          :is-loading="isLoading || isLoadingMore || isFiltersDisabled"
          :is-sort-blocked="!isFiltersApplied"
          @sort="update"
          @filter="update"
        />
        <div
          v-if="noResults"
          class="search-content__no-results"
        >
          <h2
            v-if="isEmptySearchResult"
          >
            Ничего не найдено.<br>
            Попробуйте <span @click="startNewSearch">изменить параметры поиска.</span>
          </h2>
          <h2
            v-else
          >
            Нет подходящих результатов.<br>
            Измените фильтры или <span @click="resetFilters">сбросьте их</span>.
          </h2>
        </div>
        <infinite-scroll
          v-else
          :pagination="pagination"
          :is-loading="isLoading || isUpdating || isLoadingMore"
          :is-loading-blocked="!isFiltersApplied"
          @loadMore="loadMore"
          @filtering="update"
        >
          <template>
            <hotels-cards
              v-if="viewType === 'card'"
              :collection="collection"
            />
            <hotels-table
              v-if="viewType === 'table'"
              :collection="collection"
            />
          </template>
        </infinite-scroll>
      </div>
    </div>
  </div>
</template>